import { Box } from '@mui/material';
import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { StructuredContentRenderer } from '../..';

export type LiProps = StructuredContentDocument<{
  children: StructuredContentDocument;
}>;

export const Li = ({ props }: LiProps) => {
  return (
    <Box
      component="li"
      sx={{
        display: 'flex',
        listStyle: 'none',
        '&:not(:last-child)': { marginBottom: 1 },
        'ul &::before': { content: '"\\2022"', pr: 3 },
        'ol &::before': {
          counterIncrement: 'list-item',
          content: 'counter(list-item) "."',
          pr: 3,
        },
      }}
    >
      <Box sx={{ flex: 1 }}>
        <StructuredContentRenderer doc={props.children} />
      </Box>
    </Box>
  );
};
